import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from '../components/MainLayout.vue'
import Login from '../views/operator/OperatorLogin.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'Login', component: Login },
  { path: '/', redirect: '/operator/dashboard' },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/operator/dashboard' },
      // 城市运营商管理
      { 
        path: '/city-operator', 
        name: 'CityOperator', 
        component: () => import('../views/cityOperator/Index.vue'),
        meta: { title: '运营商管理' }
      },
      // 运营商下属模块
      { 
        path: '/operator/supermarket', 
        name: 'OperatorSupermarket', 
        component: () => import('../views/operatorSupermarket/Index.vue'),
        meta: { title: '社区超市' }
      },
      { 
        path: '/operator/supermarket/merchant', 
        name: 'OperatorSupermarketMerchant', 
        component: () => import('../views/operatorSupermarket/MerchantAudit.vue'),
        meta: { title: '商家审核' }
      },
      { 
        path: '/operator/supermarket/product', 
        name: 'OperatorSupermarketProduct', 
        component: () => import('../views/operatorSupermarket/ProductAudit.vue'),
        meta: { title: '商品审核' }
      },
{ 
        path: '/operator/supermarket/share', 
        name: 'OperatorSupermarketShare', 
        component: () => import('../views/operatorSupermarket/ShareConfig.vue'),
        meta: { title: '分成配置' }
      },
      { 
        path: '/operator/supermarket/order', 
        name: 'OperatorSupermarketOrder', 
        component: () => import('../views/operatorSupermarket/SupermarketOrder.vue'),
        meta: { title: '超市订单' }
      },
      { 
        path: '/operator/supermarket/settlement', 
        name: 'OperatorSupermarketSettlement', 
        component: () => import('../views/operatorSupermarket/Settlement.vue'),
        meta: { title: '结算对账' }
      },
      { 
        path: '/operator/supermarket/share-config', 
        name: 'OperatorSupermarketShareConfig', 
        component: () => import('../views/operatorSupermarket/ShareConfig.vue'),
        meta: { title: '分成配置' }
      },
      // 二手市场管理
      { 
        path: '/operator/secondhand', 
        name: 'OperatorSecondhand', 
        component: () => import('../views/operatorSecondhand/Index.vue'),
        meta: { title: '二手市场' }
      },
      { 
        path: '/operator/secondhand/category', 
        name: 'OperatorSecondhandCategory', 
        component: () => import('../views/operatorSecondhand/Category.vue'),
        meta: { title: '分类管理' }
      },
      { 
        path: '/operator/secondhand/item', 
        name: 'OperatorSecondhandItem', 
        component: () => import('../views/operatorSecondhand/ItemList.vue'),
        meta: { title: '物品管理' }
      },
      { 
        path: '/operator/secondhand/trade', 
        name: 'OperatorSecondhandTrade', 
        component: () => import('../views/operatorSecondhand/TradeList.vue'),
        meta: { title: '交易管理' }
      },
      { 
        path: '/operator/property', 
        name: 'OperatorProperty', 
        component: () => import('../views/operatorProperty/Index.vue'),
        meta: { title: '物业公司' }
      },
      { 
        path: '/operator/merchant', 
        name: 'OperatorMerchant', 
        component: () => import('../views/operatorMerchant/Index.vue'),
        meta: { title: '商家管理' }
      },
      { 
        path: '/operator/product', 
        name: 'OperatorProduct', 
        component: () => import('../views/operatorProduct/Index.vue'),
        meta: { title: '商品管理' }
      },
      { 
        path: '/operator/purchase-order', 
        name: 'OperatorPurchaseOrder', 
        component: () => import('../views/operatorPurchaseOrder/Index.vue'),
        meta: { title: '采购订单' }
      },
      { 
        path: '/operator/stock-record', 
        name: 'OperatorStockRecord', 
        component: () => import('../views/operatorStockRecord/Index.vue'),
        meta: { title: '库存记录' }
      },
      // 蜂送到家 - 驿站管理
      { 
        path: '/operator/delivery', 
        name: 'OperatorDelivery', 
        component: () => import('../views/operatorDelivery/StationManage.vue'),
        meta: { title: '驿站管理' }
      },
      // 蜂送到家 - 功能设置
      { 
        path: '/operator/delivery/settings', 
        name: 'OperatorDeliverySettings', 
        component: () => import('../views/operatorDelivery/FunctionSettings.vue'),
        meta: { title: '功能设置' }
      },
      { 
        path: '/operator/team-leader', 
        name: 'OperatorTeamLeader', 
        component: () => import('../views/operatorTeamLeader/Index.vue'),
        meta: { title: '团长管理' }
      },
      { 
        path: '/operator/community', 
        name: 'OperatorCommunity', 
        component: () => import('../views/operatorCommunity/Index.vue'),
        meta: { title: '小区管理' }
      },
      { 
        path: '/operator/dashboard', 
        name: 'OperatorDashboard', 
        component: () => import('../views/operatorDashboard/Index.vue'),
        meta: { title: '运营数据' }
      },
      { 
        path: '/operator/settings', 
        name: 'OperatorSettings', 
        component: () => import('../views/operatorSettings/Index.vue'),
        meta: { title: '系统设置' }
      },
      // 广告管理 - 数据汇总
      { 
        path: '/operator/ad/dashboard', 
        name: 'OperatorAdDashboard', 
        component: () => import('../views/operatorAd/Dashboard.vue'),
        meta: { title: '数据汇总' }
      },
      // 广告管理 - 自用Banner
      { 
        path: '/operator/ad/self', 
        name: 'OperatorAdSelf', 
        component: () => import('../views/operatorAd/Self.vue'),
        meta: { title: '自用Banner' }
      },
      // 广告管理 - 商业Banner
      { 
        path: '/operator/ad/commercial', 
        name: 'OperatorAdCommercial', 
        component: () => import('../views/operatorAd/Commercial.vue'),
        meta: { title: '商业Banner' }
      },
      // 广告管理 - 券中心
      { 
        path: '/operator/ad/coupon-center', 
        name: 'OperatorAdCouponCenter', 
        component: () => import('../views/operatorAd/CouponCenter.vue'),
        meta: { title: '券中心' }
      },
      // 广告管理 - 竞价排名
      { 
        path: '/operator/ad/bid-ranking', 
        name: 'OperatorAdBidRanking', 
        component: () => import('../views/operatorAd/BidRanking.vue'),
        meta: { title: '竞价排名' }
      },
      // 广告管理 - 业主小程序跑马灯
      { 
        path: '/operator/ad/owner-marquee', 
        name: 'OperatorAdOwnerMarquee', 
        component: () => import('../views/operatorAd/OwnerMarquee.vue'),
        meta: { title: '跑马灯管理' }
      },
      // 广告管理 - 发券管理
      { 
        path: '/operator/ad/coupon-issue', 
        name: 'OperatorAdCouponIssue', 
        component: () => import('../views/operatorAd/CouponIssue.vue'),
        meta: { title: '发券管理' }
      },
      // 财务管理 - 分成管理
      { 
        path: '/operator/finance/revenue-share', 
        name: 'OperatorFinanceRevenueShare', 
        component: () => import('../views/operatorFinance/RevenueShare.vue'),
        meta: { title: '分成管理' }
      },
      // 财务管理 - 钱包
      { 
        path: '/operator/finance/wallet', 
        name: 'OperatorFinanceWallet', 
        component: () => import('../views/operatorFinance/Wallet.vue'),
        meta: { title: '钱包' }
      },
      // 社商通 - 社商管理
      { 
        path: '/operator/community-merchant', 
        name: 'OperatorCommunityMerchant', 
        component: () => import('../views/operatorMerchant/Index.vue'),
        meta: { title: '社商管理' }
      },
      { 
        path: '/operator/community-merchant/cooperative-bank', 
        name: 'OperatorCommunityMerchantCooperativeBank', 
        component: () => import('../views/operatorCommunityMerchant/CooperativeBank.vue'),
        meta: { title: '合作银行' }
      },
      { 
        path: '/operator/community-merchant/member-card', 
        name: 'OperatorCommunityMerchantMemberCard', 
        component: () => import('../views/operatorCommunityMerchant/MemberCard.vue'),
        meta: { title: '社商通会员卡' }
      },
      { 
        path: '/operator/community-merchant/prepaid', 
        name: 'OperatorCommunityMerchantPrepaid', 
        component: () => import('../views/operatorCommunityMerchant/PrepaidMember.vue'),
        meta: { title: '储值会员管理' }
      },
      { 
        path: '/operator/community-merchant/saved-value-cards', 
        name: 'OperatorSavedValueCards', 
        component: () => import('../views/operatorCommunityMerchant/SavedValueCards.vue'),
        meta: { title: '储值卡用户' }
      },
      { 
        path: '/operator/community-merchant/saved-value-refund', 
        name: 'OperatorSavedValueRefund', 
        component: () => import('../views/operatorCommunityMerchant/SavedValueRefundReview.vue'),
        meta: { title: '退款审核' }
      },
      { 
        path: '/operator/community-merchant/promotion', 
        name: 'OperatorCommunityMerchantPromotion', 
        component: () => import('../views/operatorCommunityMerchant/Promotion.vue'),
        meta: { title: '推广管理' }
      },

      { 
        path: '/operator/community-merchant/owner-ad', 
        name: 'OperatorCommunityMerchantOwnerAd', 
        component: () => import('../views/operatorCommunityMerchant/OwnerAdManage.vue'),
        meta: { title: '业主端广告位' }
      },
      { 
        path: '/operator/community-merchant/property-ad', 
        name: 'OperatorCommunityMerchantPropertyAd', 
        component: () => import('../views/operatorCommunityMerchant/PropertyAdManage.vue'),
        meta: { title: '物业端广告位' }
      },
      { 
        path: '/operator/community-merchant/ad-share', 
        name: 'OperatorCommunityMerchantAdShare', 
        component: () => import('../views/operatorCommunityMerchant/AdSettings.vue'),
        meta: { title: '广告分成设置' }
      },
      // 营销管理 - 秒杀管理
      { 
        path: '/operator/seckill', 
        name: 'OperatorSeckill', 
        component: () => import('../views/operatorSeckill/Index.vue'),
        meta: { title: '秒杀管理' }
      },
      { 
        path: '/operator/seckill/create', 
        name: 'OperatorSeckillCreate', 
        component: () => import('../views/operatorSeckill/Create.vue'),
        meta: { title: '创建秒杀' }
      },
      { 
        path: '/operator/seckill/edit/:id', 
        name: 'OperatorSeckillEdit', 
        component: () => import('../views/operatorSeckill/Create.vue'),
        meta: { title: '编辑秒杀' }
      },
      // 营销管理 - 团购管理
      { 
        path: '/operator/group', 
        name: 'OperatorGroup', 
        component: () => import('../views/operatorGroup/Index.vue'),
        meta: { title: '团购管理' }
      },
      { 
        path: '/operator/group/create', 
        name: 'OperatorGroupCreate', 
        component: () => import('../views/operatorGroup/Create.vue'),
        meta: { title: '创建团购' }
      },
      { 
        path: '/operator/group/edit/:id', 
        name: 'OperatorGroupEdit', 
        component: () => import('../views/operatorGroup/Create.vue'),
        meta: { title: '编辑团购' }
      },
      // 硬件设备管理
      { 
        path: '/operator/hardware', 
        name: 'OperatorHardware', 
        component: () => import('../views/operatorHardware/Index.vue'),
        meta: { title: '硬件设备管理' }
      },
      // 业主管理
      { 
        path: '/operator/owner', 
        name: 'OperatorOwner', 
        component: () => import('../views/operatorOwner/Index.vue'),
        meta: { title: '业主管理' }
      },
      // 一码通扫支付
      { 
        path: '/operator/payment', 
        name: 'OperatorPayment', 
        component: () => import('../views/operatorPayment/Index.vue'),
        meta: { title: '一码通扫支付' }
      },
      // 储值卡管理
      { 
        path: '/operator/saved-value/merchant', 
        name: 'OperatorSavedValueMerchant', 
        component: () => import('../views/operatorSavedValue/Index.vue'),
        meta: { title: '储值卡客户管理' }
      },
      {
        path: '/operator/saved-value/refund',
        name: 'OperatorSavedValueRefund',
        component: () => import('../views/operatorSavedValue/RefundIndex.vue'),
        meta: { title: '退款审核' }
      },
      // 水站管理
      {
        path: '/operator/water/order',
        name: 'WaterOrder',
        component: () => import('../views/operatorWaterStation/Order.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: '/operator/water/factories',
        name: 'WaterFactories',
        component: () => import('../views/operatorWaterStation/Factories.vue'),
        meta: { title: '水厂审核' }
      },
      {
        path: '/operator/water/station-audit',
        name: 'WaterStationAudit',
        component: () => import('../views/operatorWaterStation/StationAudit.vue'),
        meta: { title: '开通审核' }
      },
      {
        path: '/operator/water/community-pricing',
        name: 'WaterCommunityPricing',
        component: () => import('../views/operatorWaterStation/CommunityPricing.vue'),
        meta: { title: '分成设置' }
      },
      {
        path: '/operator/water/settlements',
        name: 'WaterSettlements',
        component: () => import('../views/operatorWaterStation/Settlements.vue'),
        meta: { title: '结算管理' }
      },
      {
        path: '/operator/water/supplier-audit',
        name: 'WaterSupplierAudit',
        component: () => import('../views/operatorWaterStation/SupplierAudit.vue'),
        meta: { title: '供货商审核' }
      },
      // Banner管理已合并到 广告管理 → 商业Banner（水站Banner类别）
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isLogin = localStorage.getItem('isLogin')
  const userType = localStorage.getItem('userType')
  
  // 如果访问登录页且已登录，跳转到首页
  if (to.path === '/login') {
    if (isLogin && userType === 'cityOperator') {
      next('/operator/dashboard')
    } else {
      next()
    }
    return
  }
  
  // 如果是需要登录的页面但未登录，跳转到登录页
  if (to.meta.requiresAuth && !isLogin) {
    next('/login')
  } else {
    next()
  }
})

export default router
